import {FlatTreeControl} from '@angular/cdk/tree';
import { Component, OnInit, ViewChild, Input, OnDestroy, Pipe, PipeTransform, ViewEncapsulation } from '@angular/core';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';


import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { Subscription } from 'rxjs';

import { formatDate } from '@angular/common';
import { DragulaService } from 'ng2-dragula';

//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { ServicingService } from '../../../../services/servicing.service';
import { AuditService } from '../../../../services/audit.service';
import { ProblemSolvingService } from '../../../../services/problem_solving.service';
import { DocumentMangService } from '../../../../services/document_mang.service';
import { CustomersService } from '../../../../services/customers.service';
import { ConfirmationDialogService } from '../../../general/modals/confirmation/confirmation.service';
import { GeneralService } from '../../../../services/general.service';

import { StandardCreateComponent } from '../standard_create/standard_create.component';
import { ChapterCreateComponent } from '../chapter_create/chapter_create.component';
import { DocumentInformationCreateComponent } from '../document_information_create/document_information_create.component';
//import multiselectdropdown
import { IDropdownSettings } from 'ng-multiselect-dropdown';

interface FoodNode {
  name: string;
  count?: number;
  action?: object;
  standard_id?: number;
  chapter_id?: number;
  children?: FoodNode[];
  clause_id?: number;
}


interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  count: number;
  level: number;
  standard_id?: number;
  chapter_id?: number;
  clause_id?: number;
}



declare var $: any;

@Component({
  selector: 'app-audit_standard',
  templateUrl: './audit_standard.component.html',
  styleUrls: ['./audit_standard.component.css'],
  encapsulation: ViewEncapsulation.None
})

@Pipe({
  name: 'multiSpace'
})



export class AuditStandardListComponent implements OnDestroy, OnInit {
  getPhotoBase64;


    displayedColumns: string[] = ['name', 'count', 'action'];

  private transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      count: node.count,
      action: {"standard_id":node.standard_id,"chapter_id":node.chapter_id,"clause_id":node.clause_id},
      level: level
    };
  };

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level,
    node => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    node => node.level,
    node => node.expandable,
    node => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  dropdownList = [];
  dropdownList1 = [];
  dropdownList2 = [];
  dropdownList3 = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  dropdownSettings2 = {};
  dropdownSettings3 = {};
  //dropdownSettings:IDropdownSettings;

  //common data
  data: any;


  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  datatableOptions1: any;
  datatableOptions2: any;
  datatableTrigger1: Subject<any> = new Subject();
  datatableColsDefs1: any;
  datatableColsDefs2: any;
  datatableCols1: any;
  datatableCols2: any;
  datatableAddCols1: any;

  @Input() filter1: string;
  @Input() filter2: string;
  @Input() filter3: string;
  @Input() filter4: string;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  addServicingModal: BsModalRef;
  addDocumentCreationModal: BsModalRef;
  addMaintenanceModel: BsModalRef;
  addStandardModal: BsModalRef;
  skillsAnalysisModel: BsModalRef;
  deleteOption: any;

  lang: any;
  mLang: any;
  maintenanceData: any;
  records: any;
  problem: any;
  standards: any;
  output: any;
  year: any;
  rolepermission: any;

  pageView: string = 'list';
  timezone = localStorage.getItem('timezone');
  subs = new Subscription();

  constructor(
    private servicingService: ServicingService,
    private auditService: AuditService,
    private problemsolvingService: ProblemSolvingService,
    private documentMangService: DocumentMangService,
    private customersService: CustomersService,    
    private modalService: BsModalService,
    private confirmationDialogService: ConfirmationDialogService,
    private route: ActivatedRoute,
    private router: Router,
    private generalService: GeneralService,
    private ngxRolesService: NgxRolesService,
    private dragulaService: DragulaService,

  ) {// this.dataSource.data = TREE_DATA;
  }

  // hasChild = (_: number, node: ExampleFlatNode) => node.expandable;


  ngOnInit() {


    var role = this.ngxRolesService.getRole('clients');
    
    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }

    //fetch data
    this.data = this.route.snapshot.data['sdata'];
    var role = this.ngxRolesService.getRole('servicing');

    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }
    this.getData();


    this.subs.add(this.dragulaService.dropModel("problem")
    .subscribe(({ sourceModel, targetModel, item }) => {
      let arr = []; let table = [];
      for (let employee of sourceModel) {
        arr.push(employee.timetabelId)
      }
      this.updsorting(arr, table);
    })

    );

  }


  onItemSelect(item: any) {
    console.log(item.item_id);
  }
  onSelectAll(items: any) {
    console.log(items);
  }


  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
  }

  datatableConfig(): void {


    this.datatableOptions1 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      searching: true
    }


    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }



  datatableColumns(): void {

    this.datatableCols1 = [
      { id: 2, value: 'No.', isSelected: false },
      { id: 3, value: this.lang.code, isSelected: false },
      { id: 4, value: this.lang.businessName, isSelected: false },
      { id: 5, value: this.lang.address, isSelected: false },
      { id: 6, value: this.lang.zipCode, isSelected: false },
      { id: 7, value: this.lang.city, isSelected: false },
      { id: 8, value: this.lang.province, isSelected: false },
      { id: 9, value: this.lang.taxCode, isSelected: false },
      { id: 10, value: this.lang.fiscalCode, isSelected: false },
      { id: 11, value: this.lang.phone, isSelected: false },
      { id: 12, value: this.lang.email, isSelected: false },
      { id: 13, value: this.lang.website, isSelected: false },
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }



  datatableFilter(): void {

    $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
      const filt1 = data[5] || '';
      const filt2 = data[6] || '';
      const filt3 = data[12] || '';
      // const filt4 = data[14] || '';

      let a = this.filter1;
      let aa = this.filter2;
      let aaa = this.filter3;
      // let aaaa = this.filter4;

      var status1 = false;
      var status2 = false;
      var status3 = false;
      // var status4 = false;

      if (Object.keys(a).length == 0)
        status1 = true;
      else {
        Object.keys(a).forEach(function (key) {
          if (a[key].item_id && filt1 == a[key].item_id)
            status1 = true;
        });
      }

      if (Object.keys(aa).length == 0)
        status2 = true;
      else {
        Object.keys(aa).forEach(function (key) {
          if (aa[key].item_id && filt2 == aa[key].item_id)
            status2 = true;
        });
      }

      if (Object.keys(aaa).length == 0)
        status3 = true;
      else {
        Object.keys(aaa).forEach(function (key) {
          if (aaa[key].item_id && filt3 == aaa[key].item_id)
            status3 = true;
        });
      }

      if (status1 && status2 && status3)
        return true;
      else
        return false;


    });

  }

  datatableFilterAction(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.draw();

      // dtInstance.columns().every(function () {});


    });
  }

  getData() {
    this.auditService.getstandardList()
      .subscribe(
        (res) => {
          this.lang = this.auditService.listLang(res);
          this.standards = res.data.standards;
          this.dataSource.data = res.data.dataSource;
      

          //load datatable
          this.datatableConfig();

        }
      );
  }

  error(msg: any) {
    this.generalService.notify_msg('error', msg);
  }

  redirect() {
    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.STANDARD]);
      });
  }

  success(msg: any) {

    //show success message
    this.generalService.notify_msg('success', msg);

    //redirect the current page
    this.redirect();
  }


  mulitSelect() {

    this.dropdownList = [
      { item_id: this.lang.managementsystemdoc, item_text: this.lang.managementsystemdoc },
      { item_id: this.lang.procedure, item_text: this.lang.procedure },
      { item_id: this.lang.instruction, item_text: this.lang.instruction },
      { item_id: this.lang.safetydoc, item_text: this.lang.safetydoc },
      { item_id: this.lang.specification, item_text: this.lang.specification },
    ];

    this.dropdownList1 = [
      { item_id: 'INTERNAL', item_text: 'INTERNAL' },
      { item_id: 'EXTERNAL', item_text: 'EXTERNAL' },
    ];

    this.dropdownList2 = [
      { item_id: 'VALID', item_text: 'VALID' },
      { item_id: 'PASSED', item_text: 'PASSED' },
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings1 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings2 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

  }


  export1_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      this.datatableCols1[i].isSelected = selected;
    }
    this.datatable_export1_choose_column();

  }

  export1_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].id == id)
        this.datatableCols1[i].isSelected = selected;
    }

    this.datatable_export1_choose_column();

  }

  datatable_export1_choose_column(): void {

    var table1_name = '#table1';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].isSelected)
        table1.column(parseInt(this.datatableCols1[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols1[i].id)).deselect();
    }

  }



  export2_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      this.datatableCols2[i].isSelected = selected;
    }
    this.datatable_export2_choose_column();

  }

  export2_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].id == id)
        this.datatableCols2[i].isSelected = selected;
    }

    this.datatable_export2_choose_column();

  }

  datatable_export2_choose_column(): void {

    var table1_name = '#table2';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].isSelected)
        table1.column(parseInt(this.datatableCols2[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols2[i].id)).deselect();
    }

  }

  addStandard() {

    this.addStandardModal = this.modalService.show(StandardCreateComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang } });
  }


  editStandard(data) {
    const level = data.level
    if(level == "0")
      this.addStandardModal = this.modalService.show(StandardCreateComponent, { class: 'modal-lgs', initialState: { 'ID': data.action.standard_id, 'langs': this.lang, 'mode':'edit' } });
    else if(level == "1")
      this.addStandardModal = this.modalService.show(ChapterCreateComponent, { class: 'modal-lgs', initialState: { 'ID': data.action.standard_id,'chapter_id': data.action.chapter_id, 'langs': this.lang, 'type':this.lang.editChapter, 'mode':'edit' } });      
    else if(level == "2")
      this.addStandardModal = this.modalService.show(DocumentInformationCreateComponent, { class: 'modal-lgs', initialState: { 'ID': data.action.standard_id,'chapter_id': data.action.chapter_id ,'clause_id': data.action.clause_id, 'langs': this.lang, 'type':this.lang.doc_info, 'mode':'edit' } });            
  }

  addChapter(data) {
    const level = data.level

    if(level == "0")
      this.addStandardModal = this.modalService.show(ChapterCreateComponent, { class: 'modal-lgs', initialState: {'standard_id':data.action.standard_id, 'ID': '', 'langs': this.lang, 'type':this.lang.add_chapter, 'mode':'add' } });
    else if(level == "1")
      this.addStandardModal = this.modalService.show(DocumentInformationCreateComponent, { class: 'modal-lgs', initialState: { 'ID': data.action.standard_id,'chapter_id': data.action.chapter_id, 'langs': this.lang, 'type':this.lang.doc_info, 'mode':'add' } });       
  }

  deleteStandard(data){
    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure want to delete?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;
            const level = data.level
          this.auditService.delete_standard(level,data.action.standard_id,data.action.chapter_id,data.action.clause_id)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });    
  }

  delete(ID) {

    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure want to delete?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.customersService.delete(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }


  multiDelete() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure want to delete the selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.customersService.multiDelete(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }



  multiDelete1() {

    var table1 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {
          if (!confirmed)
            return;

          this.servicingService.multiDelete1(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }

  multiDuplicate() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to duplicate the selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.customersService.multiDuplicate(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });

  }



  duplicate(ID) {

    this.confirmationDialogService.confirm('Duplicate Confirmation', 'Are you sure you duplicate this line?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.duplicate(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });


  }




  onPhotoPickerChange(ev) {
    let file = ev.target.files[0];
    file = ev.target.files[0];

    let file_name = file.name;
    if (!(/\.(csv)$/i).test(file_name)) {
      alert('Please upload valid excel file_name .csv only.');
      $('#file').val('');
    }
    else {
      let fs = new FileReader();
      fs.onload = (res: any) => {
        this.getPhotoBase64 = res.target.result;
        $('#profile_input').val('');
      };
      fs.readAsDataURL(file);
    }
  }

  onclick() {
    let profileImage = this.getPhotoBase64 ? this.getPhotoBase64.split(',').pop() : this.getPhotoBase64;

    if (profileImage != undefined && $('#file').val() != '') {
      this.customersService.updateProfile(profileImage)
        .subscribe(
          (res) => {
            if (res.status) {
              this.success(res.msg);
              $("#datatableExport2").modal("hide");

            }
            else {
              this.error(res.msg);
              $("#datatableExport2").modal("hide");

            }
          });
    }
  }

  updsorting(data: any, table: any) {
    this.customersService.sorting(data, table)
      .subscribe(
        (res) => {
          if (res.status) {
            this.success(res.msg);

          }
          else {
            this.error(res.msg);

          }
        });
  }
}
